import { DomesticContentAttestmentType, DomesticContentEligibilityTypes, SystemDesign } from 'types';

/**
 * True when opting out would strip an already-confirmed domestic content status.
 *
 * The server rejects that downgrade unless the request acknowledges it, so the UI has to recognise
 * the case to both warn the reviewer and send the acknowledgement.
 */
export const isConfirmedDowngrade = (
  selectedAttestationType: DomesticContentAttestmentType | null,
  currentEligibilityStatus?: DomesticContentEligibilityTypes,
  isEffectivelyConfirmed = false,
): boolean =>
  selectedAttestationType === DomesticContentAttestmentType.optOut &&
  (currentEligibilityStatus === DomesticContentEligibilityTypes.confirmed || isEffectivelyConfirmed);

export const buildAttestationPayload = ({
  currentSystemDesign,
  selectedAttestationType,
  currentEligibilityStatus,
  isEffectivelyConfirmed = false,
}: {
  currentSystemDesign?: SystemDesign;
  selectedAttestationType: DomesticContentAttestmentType | null;
  currentEligibilityStatus?: DomesticContentEligibilityTypes;
  isEffectivelyConfirmed?: boolean;
}) => ({
  ...currentSystemDesign,
  domesticContentAttestment: {
    valueConfirmation: selectedAttestationType !== DomesticContentAttestmentType.optOut,
    attestmentType: selectedAttestationType,
    // Only sent on a genuine downgrade. Sending it unconditionally would defeat the server guard.
    ...(isConfirmedDowngrade(selectedAttestationType, currentEligibilityStatus, isEffectivelyConfirmed) && {
      acknowledgeConfirmedDowngrade: true,
    }),
  },
});
